import * as React from 'react';

import { Activity, } from './interfaces';
import { TYPING_REQUIREMENT_FILTERS, FILL_IN_THE_BLANK, WRITING_SENTENCES, } from './shared';

import { Checkbox, DISABLED, } from '../../../../../Shared/index';

interface TypingRequirementFilterRowProps {
  typingRequirementFilters: string[],
  handleTypingRequirementFilterChange: (typingRequirementFilters: string[]) => void,
  filteredActivities: Activity[],
  typingRequirement: string;
}

interface TypingRequirementFiltersProps {
  activities: Activity[],
  filterActivities: (ignoredKey?: string) => Activity[]
  typingRequirementFilters: string[],
  handleTypingRequirementFilterChange: (typingRequirementFilters: string[]) => void,
}

const TypingRequirementFilterRow = ({ typingRequirementFilters, typingRequirement, handleTypingRequirementFilterChange, filteredActivities, }: TypingRequirementFilterRowProps) => {
  const isFillInTheBlank = typingRequirement === FILL_IN_THE_BLANK
  const activityCount = filteredActivities.filter(act => act.fill_in_the_blank === isFillInTheBlank).length
  const selected = typingRequirementFilters.includes(typingRequirement)
  const disabled = activityCount === 0

  function toggleCheckbox() {
    if (selected) {
      uncheckIndividualFilter()
    } else {
      checkIndividualFilter()
    }
  }

  function checkIndividualFilter() {
    const newTypingRequirementFilters = Array.from(new Set(typingRequirementFilters.concat([typingRequirement])))
    handleTypingRequirementFilterChange(newTypingRequirementFilters)
  }

  function uncheckIndividualFilter() {
    const newTypingRequirementFilters = typingRequirementFilters.filter(k => k !== typingRequirement)
    handleTypingRequirementFilterChange(newTypingRequirementFilters)
  }

  return (
    <div className="individual-row filter-row" key={typingRequirement}>
      <div>
        <Checkbox
          ariaLabel={`Filter by ${typingRequirement}`}
          onClick={toggleCheckbox}
          selected={selected}
          state={disabled ? DISABLED : null}
        />
        <span id={typingRequirement}>{typingRequirement}</span>
      </div>
      <span>({activityCount})</span>
    </div>
  )
}

const TypingRequirementFilters = ({ activities, filterActivities, typingRequirementFilters, handleTypingRequirementFilterChange, }: TypingRequirementFiltersProps) => {
  function clearAllTypingRequirementFilters() { handleTypingRequirementFilterChange([]) }

  const filteredActivities = filterActivities(TYPING_REQUIREMENT_FILTERS)

  const typingRequirementRows = [FILL_IN_THE_BLANK, WRITING_SENTENCES].map(tr =>
    (<TypingRequirementFilterRow
      filteredActivities={filteredActivities}
      handleTypingRequirementFilterChange={handleTypingRequirementFilterChange}
      key={tr}
      typingRequirement={tr}
      typingRequirementFilters={typingRequirementFilters}
    />)
  )

  const clearButton = typingRequirementFilters.length ? <button className="interactive-wrapper clear-filter focus-on-light" onClick={clearAllTypingRequirementFilters} type="button">Clear</button> : <span />

  return (
    <section aria-labelledby="typingRequirementsTitle" className="filter-section typing-requirements-filter-section">
      <div className="name-and-clear-wrapper">
        <h2 id="typingRequirementsTitle">Typing Requirements</h2>
        {clearButton}
      </div>
      {typingRequirementRows}
    </section>
  )
}

export default TypingRequirementFilters
